import React from "react";

const DateTimePicker = ({ value, modifier }) => {
  const getHours = () => {
    let hour = value.split(" ")[1];
    if (hour) {
      hour = hour.split(":")[0];
    } else {
      hour = "00";
    }
    return hour;
  };
  const getMinutes = () => {
    let minutes = value.split(" ")[1];
    if (minutes) {
      minutes = minutes.split(":")[1];
    } else {
      minutes = "00";
    }
    return minutes;
  };
  const handleChangeHour = (hour) => {
    let hourString = String(hour);
    if (hourString.length === 1) {
      hourString = `0${hourString}`;
    } else if (hourString.length > 2) {
      if (hourString[0] === "0") {
        hourString = hourString.substr(1);
      } else {
        hourString = hourString.substr(0, 2);
      }
    }
    if (parseInt(hourString) > 23) hourString = "23";
    if (parseInt(hourString) < 0) hourString = "0";
    const date = value.split(" ")[0];
    let minutes = value.split(" ")[1];
    if (minutes) {
      minutes = minutes.split(":")[1];
      modifier(`${date} ${hourString}:${minutes}`);
    }
  };

  const handleChangeMinutes = (minutes) => {
    let minuteString = String(minutes);
    if (minuteString.length === 1) {
      minuteString = `0${minuteString}`;
    } else if (minuteString.length > 2) {
      if (minuteString[0] === "0") {
        minuteString = minuteString.substr(1);
      } else {
        minuteString = minuteString.substr(0, 2);
      }
    }
    if (parseInt(minuteString) > 59) minuteString = "23";
    if (parseInt(minuteString) < 0) minuteString = "0";
    const date = value.split(" ")[0];
    const hours = value.split(" ")[1].split(":")[0];
    modifier(`${date} ${hours}:${minuteString}`);
  };

  return (
    <div className="row mb-3">
      <div className="col-12 col-md-6 mb-2">
        <label className="mb-1">Fecha (opcional)</label>
        <input
          type="date"
          className="form-control"
          value={value.split(" ")[0]}
          onChange={(e) => modifier(`${e.target.value} ${value.split(" ")[1]}`)}
        />
      </div>
      <div className="col-12 col-md-6 mb-2">
        <label className="mb-1">Hora (0h - 23h)</label>
        <div className="row">
          <div className="col-6">
            <input
              type="number"
              className="form-control"
              value={getHours()}
              onChange={(e) => handleChangeHour(e.target.value)}
              max={23}
              min={0}
            />
          </div>
          <div className="col-6">
            <input
              type="number"
              className="form-control"
              value={getMinutes()}
              max={59}
              min={0}
              onChange={(e) => handleChangeMinutes(e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateTimePicker;
